import { app } from '../../../../app';

app.factory('SessionRecordingReportService', SessionRecordingReportService);

/** @ngInject */
function SessionRecordingReportService($resource) {
    var rootUrl = 'app/rest/company/:companyId/report/sessionrecordings';

    return {
        sessionRecordingReport : $resource(rootUrl,{},{ 'initialReport': {
            method: 'POST',
        }}),
        sessionRecordingReportFilter : $resource(rootUrl+'/filter',{},{ 'doFilter': {
            method: 'POST',
            isArray: true
        }}),

    }
    

}


// WEBPACK FOOTER //
// ./src/portal/states/company/reports/session-recording-report/session-recording-report.service.js